import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { MODIFY_CART_DOCTOR } from '../../../apollo';
import { Cart } from '@hiwaldo/sdk/interfaces';
import { cartSlice, StoreState } from '../../../redux';

type ModifyCartDoctorEffectReturn = {
  modifyCartDoctor: (id: number, doctor: ModifyCartDoctorVariables) => void;
  loading: boolean;
  success: boolean;
  error: string | undefined;
};

interface ModifyCartDoctorVariables {
  doctorId: number | undefined;
  firstName: string;
  lastName?: string;
  company: string;
  address1?: string;
  address2?: string;
  city: string;
  zip: string;
  state?: string;
  country: string;
  phone: string;
}

export const useModifyCartDoctorEffect = (
  callback?: () => void
): ModifyCartDoctorEffectReturn => {
  const dispatch = useDispatch();
  const cart = useSelector(
    (state: StoreState) => state.orders.cart.cart
  ) as Cart;

  const [doModifyCartDoctor, modifyCartDoctorState] = useMutation(
    MODIFY_CART_DOCTOR,
    {
      onCompleted: (data) => {
        dispatch(cartSlice.actions.updateCartDoctor(data.modifyCartDoctor));
        if (callback) {
          callback();
        }
      },
    }
  );

  const { loading, called, error } = modifyCartDoctorState;

  const modifyCartDoctor = (
    id: number,
    doctor: ModifyCartDoctorVariables
  ): void => {
    const cartId = cart.id;
    const data = { ...doctor, cartId, doctorId: doctor.doctorId || null };
    const variables = { id, data };

    doModifyCartDoctor({ variables }).then();
  };

  const success = !loading && called && !error;

  return {
    modifyCartDoctor,
    loading,
    success,
    error: error?.message,
  };
};
